import React, { useState, useEffect } from "react";
import { PaperContainer } from "../../common/PaperContainer";
import { Modal, Typography } from "@material-ui/core";
import { CygniSimpleList } from "../../common/CygniList";
import { queryPrep } from "../../common/Cygni";
import { getGraficas } from "../../common/CygniRequests";
import { CygniModalList } from "../../common/CygniModal";
import { CygniLoading } from "../../common/CygniLoading";

export const MediosPorConductor = React.memo(({ query, fecha1, fecha2 }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [filtro, setFiltro] = useState("null");
  const qry = queryPrep(query);
  const f1 = fecha1 + " 00:00:00.0";
  const f2 = fecha2 + " 23:59:59.0";
  const f1Buscar = fecha1.replace(/-/g, "_");
  const f2Buscar = fecha2.replace(/-/g, "_");

  useEffect(() => {
    setData(null);

    // Gráficas
    getGraficas(qry, f1, f2, "cygnimovilconductor")
      .then(function (response) {
        setData(response);
      })
      .catch(function (error) {
        setData([]);
        console.error(error);
      });
  }, [query, fecha1, fecha2]);

  const chartClick = (chartData) => {
    if (chartData) {
      handleOpen(chartData);
    }
  };

  const handleOpen = async (selectedData) => {
    setOpen(true);
    setFiltro(selectedData);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <PaperContainer
        title="Notas por Conductor"
        exportData={data}
        exportName="medios_conductores"
      >
        {!data && <CygniLoading />}
        {data && data.length === 0 && (
          <Typography
            component="h5"
            variant="h5"
            align="center"
            style={{ marginTop: "10px" }}
          >
            No hay datos disponibles.
          </Typography>
        )}
        {data && data.length > 0 && (
          <CygniSimpleList
            data={data}
            secondarySufix=" notas"
            onItemClick={chartClick}
          />
        )}
      </PaperContainer>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div>
          <CygniModalList
            qry={qry}
            f1={f1Buscar}
            f2={f2Buscar}
            title="Detalle de notas"
            loadMore={true}
            conductor={filtro}
          />
        </div>
      </Modal>
    </React.Fragment>
  );
});
